import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import IconCircleCheckSolid from '@adv-mt/mt-svg-icons/lib/CircleCheckSolid.js'
import {
  Drawer,
  DRAWER_PLACEMENTS,
  DrawerBackdrop,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerPopup,
  DrawerPortal,
  DrawerTitle,
  DrawerViewport
} from '@adv-mt/ui/drawer'
import {Icon, ICON_SIZES} from '@adv-mt/ui/icon'

import useDrawerPlacement from '../hooks/useDrawerPlacement.js'
import {BASE_CLASS} from './FormFields.js'

const DEFAULT_TITLE_KEY = 'CONTACT_SELLER_V2.FORM.DRAWER_TITLE'

const FormDrawer = ({open, onOpenChange, triggerRef, children, hasContacted = false, titleKey = DEFAULT_TITLE_KEY}) => {
  const {i18n} = useContext(Context)
  const {placement} = useDrawerPlacement()

  return (
    <Drawer open={open} onOpenChange={onOpenChange} placement={placement} modal>
      <DrawerPortal>
        <DrawerBackdrop className={`${BASE_CLASS}-drawerBackdrop`} />
        <DrawerViewport>
          <DrawerPopup
            className={cx(`${BASE_CLASS}-drawerPopup`, {
              [`${BASE_CLASS}-drawerPopup--bottom`]: placement === DRAWER_PLACEMENTS.BOTTOM
            })}
            finalFocus={triggerRef}
            placement={placement}
          >
            <DrawerContent>
              <DrawerHeader>
                {hasContacted ? (
                  <div className={`${BASE_CLASS}-drawerSuccessHeader`}>
                    <Icon size={ICON_SIZES.SM} className={`${BASE_CLASS}-drawerSuccessIcon`}>
                      <IconCircleCheckSolid size={ICON_SIZES.SM} />
                    </Icon>
                    <DrawerTitle className={`${BASE_CLASS}-drawerSuccessTitle`}>
                      {i18n.t('CONTACT_SELLER_V2.SUCCESS.DRAWER_TITLE')}
                    </DrawerTitle>
                  </div>
                ) : (
                  <DrawerTitle>{i18n.t(titleKey)}</DrawerTitle>
                )}
                <DrawerCloseButton aria-label={i18n.t('COMMON_CLOSE')} />
              </DrawerHeader>
              <DrawerBody className={`${BASE_CLASS}-drawerBody`}>{children}</DrawerBody>
            </DrawerContent>
          </DrawerPopup>
        </DrawerViewport>
      </DrawerPortal>
    </Drawer>
  )
}

FormDrawer.displayName = 'ContactFormV2FormDrawer'

FormDrawer.propTypes = {
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  triggerRef: PropTypes.object,
  children: PropTypes.node,
  hasContacted: PropTypes.bool,
  titleKey: PropTypes.string
}

export default FormDrawer
